<template>
  <div>
    <b-navbar toggleable="lg" type="dark">
      <b-navbar-brand href="https://www.e-pokemon.pl/">POKéMON</b-navbar-brand>
      <b-navbar-nav>
        <b-nav-item-dropdown text="Interaktywne mapy">
          <b-dropdown-item href="/mapa">Mapy Pokémon</b-dropdown-item>
          <b-dropdown-divider></b-dropdown-divider>
          <b-dropdown-item href="/mapa/Kanto">Gen 1 – Kanto</b-dropdown-item>
          <b-dropdown-item href="/mapa/Johto">Gen 2 – Johto</b-dropdown-item>
          <b-dropdown-item href="/mapa/Hoenn">Gen 3 – Hoenn</b-dropdown-item>
          <b-dropdown-item href="/mapa/Sinnoh">Gen 4 – Sinnoh</b-dropdown-item>
          <b-dropdown-item href="/mapa/Unova">Gen 5 – Unova</b-dropdown-item>
          <b-dropdown-item href="/mapa/Unova2">Gen 5 – Unova 2</b-dropdown-item>
          <b-dropdown-divider></b-dropdown-divider>
          <b-dropdown-item href="/mapa/Kanto-FR-LG">Gen 3 – Kanto</b-dropdown-item>
          <b-dropdown-item href="/mapa/Johto-HG-SS">Gen 4 – Johto</b-dropdown-item>
        </b-nav-item-dropdown>
        <b-nav-item-dropdown right text="Solucje">
          <b-dropdown-item href="/Solucja-Crystal-Gold-Silver">Solucja do Crystal, Gold i Silver</b-dropdown-item>
          <b-dropdown-item href="/Solucja-Emerald-Ruby-Sapphire">Solucja do Emerald, Ruby i Sapphire</b-dropdown-item>
        </b-nav-item-dropdown>
      </b-navbar-nav>
    </b-navbar>
    
    <Suspense> <!-- umieść router-view wewnątrz <Suspense> -->
      <template #default>
        <!-- router-view z komponentem <Pokemon> -->
        <router-view></router-view>
      </template>
      <template #fallback>
        <!-- zawartość alternatywna podczas ładowania -->
        Trwa wczytywanie mapy...
      </template>
    </Suspense>

  </div>
</template>

<script>
export default {
}
</script>

<style>
@font-face {
    font-family: 'Readex Poke';
    src: url('https://www.e-pokemon.pl/font/readex-poke.woff2') format('woff2 supports variations'),
         url('https://www.e-pokemon.pl/font/readex-poke.woff2') format('woff2-variations');
    font-weight: 160 700;
    font-style: normal;
    font-display: swap;
}
@font-face {
    font-family: 'Readex fallback';
    size-adjust: 108%;
    src: local('Arial');
}
* {
    box-sizing: border-box;
}
body {
    background-color: #37474f;
    margin: 0;
}
ul{margin-top: 0;}
th{font-variation-settings:"wght"500;}

.navbar {
    background-color: #232c2f;
    display: flex;
    position: relative;
    padding: 0.5rem 1rem;
    flex-wrap: wrap;
    align-items: center;
    justify-content: space-between;
}
@media (min-width: 992px) {
.navbar {
    padding-right: 1.5rem;
    padding-left: 1.5rem;
}
}

.navbar-brand {
    color: #fff;
    display: inline-block;
    margin-right: 1rem;
    font-size: 1.25rem;
    white-space: nowrap;
}

.navbar-nav {
    display: flex;
    flex-direction: column;
    padding-left: 0;
    margin-bottom: 0;
    list-style: none;
    align-items: flex-end;
}
@media (min-width: 992px) {
.navbar-nav {
    flex-direction: row;
}
}
input, button {
    font-family: inherit;
    font-size: inherit;
    line-height: inherit;
}
.dropdown {
    position: relative;
}

.navbar-nav .nav-link {
    color: hsla(0,0%,100%,.5);
}
.navbar-nav .nav-link:focus, .navbar-nav .nav-link:hover {
    color: hsla(0,0%,100%,.75);
}
.navbar-nav .show>.nav-link {
    color: #fff;
}
.nav-link {
    display: block;
    padding: 0.5rem 1rem;
}
@media (min-width: 992px) {
.navbar-nav .nav-link {
    padding-right: 0.5rem;
    padding-left: 0.5rem;
}
}
.dropdown-toggle {
    white-space: nowrap;
}
[role=button] {
    cursor: pointer;
}
a {
    text-decoration: none;
    background-color: transparent;
}

.dropdown-menu {
    position: absolute;
    top: 100%;
    right: 0;
    left: auto;
    z-index: 1000;
    display: none;
    float: left;
    min-width: 12rem;
    padding: 0.5rem 0;
    margin: 0.125rem 0 0;
    font-size: 1rem;
    text-align: left;
    list-style: none;
    background-color: #fff;
    background-clip: padding-box;
    border: 1px solid rgba(0,0,0,.15);
    border-radius: 0.25rem;
}
.dropdown-menu.show {
    display: block;
}

.dropdown-item {
    display: block;
    width: 100%;
    padding: 0.25rem 1.15rem;
    clear: both;
    font-weight: 400;
    color: #212529;
    border: 0;
}
.dropdown-item:focus, .dropdown-item:hover {
    color: #16181b;
    text-decoration: none;
    background-color: #e9ecef;
}
@media (min-width: 992px) {
.dropdown-item {
    white-space: nowrap;
}
}

.dropdown-toggle:after {
    display: inline-block;
    margin-left: .255em;
    vertical-align: .255em;
    content: "";
    border-top: .3em solid;
    border-right: .3em solid transparent;
    border-bottom: 0;
    border-left: .3em solid transparent;
}

.container-fluid {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    margin-right: auto;
    margin-left: auto;
}
@media (min-width: 992px) {
.container-fluid {
    padding-right: 15px;
    padding-left: 15px;
}
}
p {
    margin-top: 0;
}

.btn {
    font-weight: 400;
    text-align: center;
    vertical-align: middle;
    user-select: none;
    background-color: transparent;
    border: 1px solid transparent;
    padding: .375rem .75rem;
    font-size: 1rem;
    line-height: 1.5;
    border-radius: .25rem;
    transition: color .15s ease-in-out,background-color .15s ease-in-out,border-color .15s ease-in-out,box-shadow .15s ease-in-out;
}
.btn:not(:disabled):not(.disabled) {
    cursor: pointer;
}

body {
  font-family: 'Readex Poke', 'Readex fallback';
  font-weight: 345;
  letter-spacing: 0.01ch;
  text-align: center;
  color: #e6e6e6;
  background-color: #37474f;
  min-height: 100vh;
  line-height: 1.5rem;
}
footer table a {
  color:grey;
}

.tooltip-inner {
    max-width: 200px;
    padding: .25rem .5rem;
    color: #fff;
    text-align: center;
    background-color: #000;
    border-radius: .25rem;
}
</style>
